<template>
  <Navigation v-if="user?.hasGenTwoProAccess || user?.hasDocumentHubAccess" :user="user" />
  <main>
    <Alert type="informative" v-if="hashChanged" is-outlined>
      <div class="message-box p-grid">
        <div class="flex flex-col gap-2.5 p-2.5 w-full p-mx-2">
          <p>Gentwo Pro has been updated. Please reload to ensure you have the latest updates</p>
          <p>
            <Button unstyled class="button button-primary button-md" @click="reloadApp"
              >Reload</Button
            >
          </p>
          <p v-if="newHash != ''">
            <b>New Version:</b> {{ newHash }} (Current Version: {{ currentHash }})
          </p>
        </div>
      </div>
    </Alert>
    <ImpersonatePopup v-if="user?.isImpersonating" />
    <router-view />
  </main>
  <Toast position="bottom-right" :closable="false">
    <template #icon>
      <i class="pi pi-info-circle" style="font-size: 1.7rem" />
    </template>
    <template #closeicon>
      <i class="pi pi-times-circle" style="font-size: 1.5rem" />
    </template>
  </Toast>
  <FeaturePopup :enabled="userLogged" v-if="!user?.hasDocumentHubAccess" />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useApiStore } from "@/stores/api";
import { useAccountStore } from "@/stores/account";
import Toast from "primevue/toast";
import Button from "primevue/button";
import FeaturePopup from "@/components/FeaturePopup";
import ImpersonatePopup from "@/components/elements/ImpersonatePopup";
import Navigation from "@/components/Navigation";
import { reload } from "@/mixins/reload";
import Alert from "@/components/elements/Alert.vue";

export default defineComponent({
  name: "App",
  mixins: [reload],
  setup: () => {
    return {
      apiStore: useApiStore(),
      accountStore: useAccountStore(),
    };
  },
  components: {
    Alert,
    Toast,
    FeaturePopup,
    Button,
    ImpersonatePopup,
    Navigation,
  },
  computed: {
    user() {
      return this.accountStore.user;
    },
    userLogged() {
      return this.accountStore.userLogged;
    },
  },
  created() {
    this.apiStore.initInterceptors(this.$toast);
    this.initVersionCheck();
  },
});
</script>

<style lang="scss">
#app {
  display: flex;
  min-height: 100%;
}
main {
  width: 100%;
  display: flex;
  flex-direction: column;
  flex: 1;
  text-align: left;
  padding: var(--grid-gutter) 2rem;

  & > .p-grid {
    flex: 1;
    margin: calc(-1 * var(--grid-gutter)) -2rem !important;
  }
  & > .page-header {
    padding-top: var(--grid-gutter);
  }
}
.message-box {
  color: var(--primary-color);
}
.p-toast {
  width: auto;
  max-width: calc(100% - 40px);
}
</style>
